export default __webpack_public_path__ + "static/media/sd.ffdec317.jpg";